module.exports = __webpack_public_path__ + "img/add-node-icon.bbbf109a.svg";